import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const ForgotPassword = () => {
  const navigate = useNavigate();
  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p>Please enter email address</p>
        <form>
          <div className="control_group">
            <label>Email Address</label>
            <TextField placeholder="Enter Email Address" hiddenLabel fullWidth></TextField>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" onClick={() => navigate("/otp")}>Submit</Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p><span className="link" onClick={() => navigate("/")}><KeyboardBackspaceIcon /> Back to Login</span></p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
